module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ibox"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ibox-content ibox-heading"
  }, [_vm._v("\n      Generate URL for profiles portal service\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "ibox-content"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "label-width": "158px"
    }
  }, [(_vm.generateUrlSuccess) ? _c('el-form-item', {
    attrs: {
      "label": "Generated Url"
    }
  }, [_c('div', {
    staticClass: "copy-input"
  }, [_c('el-input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.generatedUrl),
      callback: function($$v) {
        _vm.generatedUrl = $$v
      },
      expression: "generatedUrl"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "copy-button",
    attrs: {
      "type": "text",
      "icon": "el-icon-document-copy"
    },
    on: {
      "click": _vm.copyUrl
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Generate URL",
      "prefix-icon": "el-icon-refresh"
    }
  }, [_c('el-button', {
    attrs: {
      "loading": _vm.loadingGenerateUrl,
      "disabled": _vm.generateUrlSuccess,
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": _vm.generate
    }
  }, [_vm._v("Generate")])], 1)], 1)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibox-title"
  }, [_c('h5', [_vm._v("Profiles Portal URL")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f6a827d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/permission/publishing/GeneratePermissionURL.vue
// module id = 3142
// module chunks = 3